// Web-only push notification service (no Expo dependencies)
// For full push notifications, consider using Web Push API with Service Workers

class PushNotificationService {
  private pushToken: string | null = null;

  async registerForPushNotifications(): Promise<string | null> {
    console.info('Push notifications are not available in the web version. Please use the mobile app.');
    
    // Optional: Implement Web Push API with Service Workers
    // https://developer.mozilla.org/en-US/docs/Web/API/Push_API
    
    if ('Notification' in window && 'serviceWorker' in navigator) {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        console.log('Web notification permission granted');
        // You could register a service worker here for web push
      }
    }
    
    return null;
  }

  async sendTokenToServer(userId: string, token: string) {
    try {
      const API_URL = (import.meta as any).env?.VITE_API_URL || 'http://localhost:5000';
      
      const response = await fetch(`${API_URL}/api/notifications/register-token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          userId,
          pushToken: token,
          platform: 'web'
        })
      });

      if (!response.ok) {
        throw new Error('Failed to register push token');
      }

      console.log('✅ Push token registered with server');
    } catch (error) {
      console.error('Error sending token to server:', error);
    }
  }

  addNotificationReceivedListener(listener: (notification: any) => void) {
    console.info('Notification listeners not available in web version');
    return { remove: () => {} };
  }

  addNotificationResponseListener(listener: (response: any) => void) {
    console.info('Notification listeners not available in web version');
    return { remove: () => {} };
  }

  async scheduleLocalNotification(title: string, body: string, data?: any) {
    console.info('Local notifications not available in web version');
    
    // Optional: Show browser notification if permission granted
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification(title, {
        body,
        data,
        icon: '/favicon.ico'
      });
    }
  }
}

export default new PushNotificationService();
